/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAgreementModificationInformationResponse
 */
export interface ServiceAgreementModificationInformationResponse {
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModificationInformationResponse
     */
    productAttributeId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModificationInformationResponse
     */
    uiSchema?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModificationInformationResponse
     */
    jsonSchema?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModificationInformationResponse
     */
    formValues?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceAgreementModificationInformationResponse
     */
    forceRepaperingEnabled?: boolean;
}

/**
 * Check if a given object implements the ServiceAgreementModificationInformationResponse interface.
 */
export function instanceOfServiceAgreementModificationInformationResponse(value: object): value is ServiceAgreementModificationInformationResponse {
    return true;
}

export function ServiceAgreementModificationInformationResponseFromJSON(json: any): ServiceAgreementModificationInformationResponse {
    return ServiceAgreementModificationInformationResponseFromJSONTyped(json, false);
}

export function ServiceAgreementModificationInformationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementModificationInformationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'productAttributeId': json['productAttributeId'] == null ? undefined : json['productAttributeId'],
        'uiSchema': json['uiSchema'] == null ? undefined : json['uiSchema'],
        'jsonSchema': json['jsonSchema'] == null ? undefined : json['jsonSchema'],
        'formValues': json['formValues'] == null ? undefined : json['formValues'],
        'forceRepaperingEnabled': json['forceRepaperingEnabled'] == null ? undefined : json['forceRepaperingEnabled'],
    };
}

export function ServiceAgreementModificationInformationResponseToJSON(json: any): ServiceAgreementModificationInformationResponse {
    return ServiceAgreementModificationInformationResponseToJSONTyped(json, false);
}

export function ServiceAgreementModificationInformationResponseToJSONTyped(value?: ServiceAgreementModificationInformationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productAttributeId': value['productAttributeId'],
        'uiSchema': value['uiSchema'],
        'jsonSchema': value['jsonSchema'],
        'formValues': value['formValues'],
        'forceRepaperingEnabled': value['forceRepaperingEnabled'],
    };
}

